// extracted by mini-css-extract-plugin
export default {"root":"qs0US8q80RaHp9uZ7HCT","left":"Vt9sOC9FLr6QpBjAKvsz","icon":"gKfCWF6LYYsyWjmdOfFQ"};